<template>
  <b-navbar toggleable="lg" type="dark">
    <b-navbar-brand>

      <!-- <router-link class="spacing" :to="'/'+(userType ? userType == 'organization' ? 'organizations/index' : userType : '')">
        <img src="/img/logo-aid-heared1.png" />
      </router-link> -->

      <!-- <router-link class="spacing"> -->
        <img src="/img/logo-aid-heared1.png" />
      <!-- </router-link> -->

    </b-navbar-brand>

    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>

        <!-- <div class="nav-item mx-2" v-if="userType == 'organization'">
          <router-link class="spacing" to="/organization"><b>Area Riservata Organizzazioni</b></router-link>
        </div> -->

        <div class="nav-item mx-2" v-if="userType == 'organization'">
          <router-link v-b-tooltip.hover title="Home" class="spacing" style="color: #6f6656 !important;" to="/organizations/index"><font-awesome-icon icon="home" style="font-size: 25px;"/></router-link>
        </div>

        <div class="nav-item mx-2" v-if="userType == 'translator'">
          <router-link class="spacing" to="/translator"><b>Area Riservata Traduttori</b></router-link>
        </div>

        <div class="nav-item mx-2">
          <router-link class="spacing" to="/organizations" v-if="userType == 'translator'"
            ><b>Organizzazioni Accreditate</b></router-link
          >
        </div>

        <!-- <div class="nav-item mx-2">
          <router-link class="spacing" to="/translators" v-if="userType == 'organization'"
            ><b>Ricerca Traduttori</b></router-link
          >
        </div> -->

        <div class="nav-item mx-2" v-if="userType == 'translator'">
            <router-link
            class="spacing"
            :to="`/translators/view/${this.$store.state.auth.user.id}`">
              <b>Il Mio Profilo</b>
            </router-link>
        </div>

        <!-- <div class="nav-item mx-2" v-if="userType == 'organization'">
          <router-link
          class="spacing"
          :to="`/voice_to_voice`">
            <b>Voice to Voice</b>
          </router-link>
        </div> -->


      </b-navbar-nav>

      <b-navbar-nav class="ml-auto spacing" id="last-menu">
        <!-- <img src="/img/logo_nuovo.png" class="mt-2" /> -->
        <b-img width="250px" style="margin:auto;" src="/img/logo_nuovo.png" class="mt-2"></b-img>
        <b-nav-item href @click.prevent="logOut" v-if="loggedIn" class="logout">
          <b-icon-arrow-right></b-icon-arrow-right> LogOut
        </b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import util from "@/mixing/util";

export default {
  name: "top-navbar",
  mixins: [util],
  data() {
    return {
      experimental: process.env.VUE_APP_EXPERIMENTAL,
    };
  },
  methods: {
    logOut() {
      this.$store.state.auth.user.userType = null;
      this.$store.dispatch("auth/logout");
      this.$router.push("/");
    },
  },
  computed: {
    loggedIn() {
      if (this.$store.state.auth.user === undefined) {
        return false;
      }
      if (this.$store.state.auth.user == null) {
        return false;
      }
      return true;
    },
    userType() {
      if (this.$store.state.auth.user !== null) {
        return this.$store.state.auth.user.userType;
      }
      return null;
    },
  },
};
</script>

<style>
nav {
  background: #f49538;
  /* padding: 10px; */
}
nav .navbar-toggler {
  color: #fff;
}

nav a {
  font-size: medium;
  /* padding: 0px 10px; */
  text-decoration: none;
  color: #222126;
  font-weight: bold;
}
.navbar-nav .dropdown-menu {
  background-color: #f49538 !important;
  border: 0;
}
nav a.router-link-exact-active,
nav a:hover {
  color: white;
}
nav img {
  height: 30px;
}
.navbar-dark .navbar-nav .nav-link {
  color: #000;
}

.navbar-dark .navbar-nav .nav-link {
  color: #6f6656 !important;
  font-size: inherit;
  margin-top: 5px;
}

nav .dropdown-item a {
  font-size: medium;
  font-weight: normal;
  padding: auto;
}

.navbar-nav .dropdown-menu {
  background-color: orangered;
}
</style>
